import { render, staticRenderFns } from "./buttonConfig.vue?vue&type=template&id=005e010e&"
import script from "./buttonConfig.vue?vue&type=script&lang=js&"
export * from "./buttonConfig.vue?vue&type=script&lang=js&"
import style0 from "./buttonConfig.vue?vue&type=style&index=0&id=005e010e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports